export const testColumns = [
  {
    data: "ordStatus",
    title: "Actions",
    active:true,
    canToggle:false
  },
  {
    data: "prodName",
    title: "Product Name",
    active: true,
    canToggle: false
  },
  {
    data: "description",
    title: "Description",
    active: true,
    canToggle: true
  },
  {
    data: "facility",
    title: "Facility",
    active: true,
    canToggle: true
  },
  {
    data: "available",
    title: "Available",
    active: true,
    canToggle: true
  },
  {
    data: "ordStatus",
    title: "Order Status",
    active: true,
    canToggle: true
  },
  {
    data: "allocated",
    title: "Allocated",
    active: true,
    canToggle: true
  }
];


// WEBPACK FOOTER //
// ./src/components/lookupTable/stores/testColumnModalData.js